export interface LRU<Key, Value> {
  get(key: Key): Value | undefined;
  put(key: Key, value: Value): void;
}

/**
 * 一个简单的 LRU 淘汰算法
 */
export class LRUCache<Key, Value> implements LRU<Key, Value> {
  private static DEFAULT_CAPACITY = 8;
  private cache: Key[];
  private map: Map<Key, Value>;
  private readonly capacity: number;
  constructor(capacity: number = LRUCache.DEFAULT_CAPACITY) {
    this.capacity = capacity > 0 ? capacity : LRUCache.DEFAULT_CAPACITY;
    this.cache = [];
    this.map = new Map();
  }

  public getCapacity() {
    return this.capacity;
  }

  public get(key: Key): Value | undefined {
    if (!this.map.has(key)) {
      return;
    }
    this.makeRecently(key);
    return this.map.get(key);
  }

  public put(key: Key, value: Value): void {
    if (this.map.has(key)) {
      this.makeRecently(key);
      // 更新
      this.map.set(key, value);
      return;
    }
    // 容量达到上下，删除 least recent used.
    if (this.cache.length >= this.capacity) {
      this.removeLeastRecently();
    }

    this.addRecently(key, value);
  }

  private makeRecently(key: Key) {
    // 由于再 makeRecently 之前，我们就通过 map.has(key) 判断出 存在性。
    // 所以这里可以不用判断 index === -1
    const index = this.cache.indexOf(key);
    this.cache.splice(index, 1);
    this.cache.push(key);
  }

  public remove(key: Key) {
    // 主动移除指定的缓存
    this.map.delete(key);
    const index = this.cache.indexOf(key);
    if (index !== -1) {
      this.cache.splice(index, 1);
    }
  }
  private removeLeastRecently() {
    // 由于只有当 this.cache.length >= this.capacity 才会调用该方法，、
    // 所以所得到的 key 值是存在的
    const key = this.cache.shift();
    if (key) {
      this.map.delete(key);
    }
  }
  private addRecently(key: Key, value: Value) {
    this.cache.push(key);
    this.map.set(key, value);
  }
}
